import React from 'react';
import ExcelIcon from '../../resources/icon/excel-export.png';
import {Link} from "react-router-dom";
import AlertModal from "../basic/AlertModal";
import {useSelector} from "react-redux";
import {useExcelDownloadClick} from "../commonmethod/excelMethod";
import Qr from "../../resources/icon/qr-icon.png"
import Memo from "../../resources/icon/memo.png"
import Printer from "../../resources/icon/pirnter-bw.png"
import {canInsertByLicense, isAdmin} from "../commonmethod/CommonMethod";

/*
* 각각 insert, del, excel, printer 의 display 여부에 따라 버튼을 보여주거나 감춤.
* 각 버튼 별로 listener 에 해당 버튼 클릭시 발생할 이벤트 넘겨받음
* asset 은 자산에서만 쓰는 옵션
* */
function UtilsBox({insert, del, excel, printer, disables, enables, qr, assetCheck, memo, userCheck}) {
    const license = useSelector(state =>state.auth.license)
    const canInsert = canInsertByLicense({ license, assetCheck, userCheck });
    const user = useSelector((state) => state.auth.user);
    const handleExcelDownload = useExcelDownloadClick(excel?.search ?? {});
    const isAdminUser = isAdmin(user);
    const platFrom = useSelector(state =>state.auth.platFrom)
    return (
        <div className="w-[100%] h-[60px] pt-[16px] util-box align-middle">
            { insert ?
                (canInsert
                    ? <Link className={`btn_save`} to={insert ?? ''}>등록</Link>
                    : <button type="button" className={`btn_save_license-out`}>등록</button>)
                : ""
            }
            { del &&
                <AlertModal
                    triggerName={"삭제"} handler={del}
                    triggerClassName={"btn_delete top_gap"} actionName={"삭제하기"}
                    title={"선택한 데이터를 삭제 하시겠습니까?"}
                    description={"선택한 데이터가 모두 지워지며 복원할 수 없습니다."}
                />}
            { disables &&
                <AlertModal
                    triggerName={"비활성화"} handler={disables}
                    triggerClassName={"btn_delete top_gap"} actionName={"비활성화하기"}
                    title={"선택한 데이터를 비활성화 하시겠습니까?"}
                    description={""}
                />
            }
            { enables &&
                <AlertModal
                    triggerName={"활성화"} handler={enables}
                    triggerClassName={"btn_save top_gap"} actionName={"활성화하기"}
                    title={"선택한 데이터를 활성화 하시겠습니까?"}
                    description={""}
                />
            }
            { excel && isAdminUser &&
                <abbr title={"엑셀 다운로드"}>
                    <button
                        type="button"
                        className="float-right mr-2"
                        onClick={handleExcelDownload(excel.key)}
                    >
                        <img src={ExcelIcon} className="w-[30px] h-[30px] mt-[3px] border" alt="excel-icon"/>
                    </button>
                </abbr>
            }
            { printer &&
                <abbr title={"인쇄하기"}>
                    <button className="float-right mr-3" onClick={() => window.print()}>
                        <img src={Printer} className={`w-[30px] h-[30px] mt-[5px] border`}/>
                    </button>
                </abbr>
                }

            {qr &&
                <abbr title={"QR 인쇄"}>
                    <button className="float-right mr-3" onClick={qr}>
                        <img src={Qr} className={`w-[30px] h-[30px] mt-[5px] p-[2px] border`}/>
                    </button>
                </abbr>
                }


            { (platFrom=='ITAM' || platFrom=='IAM') && memo &&
                <abbr title={"자산기록"}>
                    <button className="float-right mr-3" onClick={memo}>
                        <img src={Memo} className={`w-[30px] h-[30px] mt-[5px] p-[2px] border`}/>
                    </button>
                </abbr>
                }
        </div>
    );
}

export default UtilsBox;
